import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
// import { signUp } from '../../auth/authService';

const Form1 = ({username, setUsername, email, setEmail, password, setPassword, setServerMessage, setRegisterConfirmation, signUp}) => {
  const [confirmEmail, setConfirmEmail] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [validationErrors, setValidationErrors] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const signUpValidation = () => {
    const errors = [];

    // Username validation
    if (!username) {
    errors.push('Username is required');
    } else if (username.trim().length < 3) {
        errors.push('Username must be at least 3 characters long');
    } else if (username.length > 20) {
        errors.push('Username must be no more than 20 characters');
    } else if (!/^[a-zA-Z0-9_-]+$/.test(username)) {
        errors.push('Username can only contain letters, numbers, underscores, and hyphens');
    } else if (/^\d/.test(username)) {
        errors.push('Username cannot start with a number');
    }

    if (email !== confirmEmail) {
      errors.push('Emails do not match');
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errors.push('Please enter a valid email address');
    }

    if (password !== confirmPassword) {
      errors.push('Passwords do not match');
    }
  
    if (password.length < 8) {
      errors.push('Password must be at least 8 characters long');
    }
  
    if (!/\d/.test(password)) {
      errors.push('Password must contain at least one number');
    }
  
    if (!/[!@#$%^&*]/.test(password)) {
      errors.push('Password must contain at least one special character');
    }
  
    if (!/[A-Z]/.test(password)) {
      errors.push('Password must contain at least one uppercase letter');
    }
  
    if (!/[a-z]/.test(password)) {
      errors.push('Password must contain at least one lowercase letter');
    }
  
    setValidationErrors(errors);
    if (errors.length > 0) {
        return false;
    }
    
    return true;
  };


  const handleSignUp = async (e) => {
    
    setIsLoading(true);
    const validation = signUpValidation();

    if (!validation) {
        setIsLoading(false);
        return;
    } else {
        setValidationErrors(null);
    }
    
    const response = await signUp();

    if (response.success) {
      setServerMessage(response);
      // Redirect to confirmation code page by updating the state in the parent component
      setRegisterConfirmation(true);
    } else {
      setServerMessage(response);
    }
    setIsLoading(false);
};

  return (
    <div className='background-grid d-flex flex-column justify-content-center align-items-center landscape-spacing' style={{minHeight: "80vh"}}>
      <div className='d-flex flex-column custom-container'>
        <h2 className='pb-3 text-center' style={{fontWeight: 400}}>Sign up</h2>
        {validationErrors && (
            <div className="alert bg-danger text-white" role="alert">
                {validationErrors.map((err) => {
                    return (
                        <p key={err} style={{marginBottom: "0px", fontSize: "14px", color: "white"}}>
                            {err}
                        </p>
                    );
                })}
            </div>
        )}
        <input
            className="custom-input rounded"
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{ marginBottom: "20px", height: "45px", backgroundColor: "#171A29" }}
        />
        <input
            className="custom-input rounded"
            type="text"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ marginBottom: "20px", height: "45px", backgroundColor: "#171A29" }}
        />
        <input
            className="custom-input rounded"
            type="text"
            placeholder="Confirm Email"
            value={confirmEmail}
            onChange={(e) => setConfirmEmail(e.target.value)}
            style={{ marginBottom: "20px", height: "45px", backgroundColor: "#171A29" }}
        />
        <div style={{ position: "relative", marginBottom: "20px" }}>
            <input
                className="custom-input rounded"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                onFocus={(e) => (e.target.style.borderColor = "#FFCC19")} // Change border color on focus
                onBlur={(e) => (e.target.style.borderColor = "#3C3E4C")} // Reset border color on blur
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                    height: "45px",
                    backgroundColor: "#171A29",
                    width: "100%", // Ensure the input takes the full width of the container
                    paddingRight: "40px", // Add padding to make space for the icon
                    border: "1px solid #3C3E4C",
                    color: "white",
                }}
            />
            <FontAwesomeIcon
                icon={showPassword ? faEyeSlash : faEye} // Toggle between eye and eye-slash icons
                onClick={() => setShowPassword(!showPassword)} // Toggle password visibility
                style={{
                    position: "absolute",
                    right: "10px", // Position the icon 10px from the right edge of the input
                    top: "50%", // Center the icon vertically
                    transform: "translateY(-50%)", // Adjust for vertical centering
                    cursor: "pointer",
                    color: "#AEAFBA",
                    width: "20px",
                    height: "20px",
                }}
            />
        </div>
        <div style={{ position: "relative", marginBottom: "20px" }}>
            <input
                className="custom-input rounded"
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm Password"
                onFocus={(e) => (e.target.style.borderColor = "#FFCC19")} // Change border color on focus
                onBlur={(e) => (e.target.style.borderColor = "#3C3E4C")} // Reset border color on blur
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={{
                    height: "45px",
                    backgroundColor: "#171A29",
                    width: "100%", // Ensure the input takes the full width of the container
                    paddingRight: "40px", // Add padding to make space for the icon
                    border: "1px solid #3C3E4C",
                    color: "white",
                }}
            />
            <FontAwesomeIcon
                icon={showConfirmPassword ? faEyeSlash : faEye} // Toggle between eye and eye-slash icons
                onClick={() => setShowConfirmPassword(!showConfirmPassword)} // Toggle password visibility
                style={{
                    position: "absolute",
                    right: "10px", // Position the icon 10px from the right edge of the input
                    top: "50%", // Center the icon vertically
                    transform: "translateY(-50%)", // Adjust for vertical centering
                    cursor: "pointer",
                    color: "#AEAFBA",
                    width: "20px",
                    height: "20px",
                }}
            />
        </div>
        <p className='text-center' style={{fontSize: "14px", paddingBottom: "10px"}}>By signing up, you agree to our <a href='/privacy' style={{color: 'white', fontWeight: 600, textDecoration: 'none'}}>Privacy Policy</a></p>
        <button className='rounded w-100' style={{backgroundColor: '#FFCC19', height: "45px", fontWeight: 600, border: "none", color: "black"}} onClick={() => handleSignUp()} disabled={isLoading}>{isLoading ? 'Signing Up...' : 'Sign Up'}</button>
        <p className='text-center mb-0' style={{color: '#AEAFBA', fontWeight: 400, fontSize: "14px", marginTop: "20px"}}>Already have an account? <a href='/login' style={{color: 'white', fontWeight: 600, textDecoration: 'none'}}>Sign In</a></p>
    </div>
  </div>
  )
}

export default Form1